import { MetricCardsSkeleton, UsageChartSkeleton } from '@/components/usage-skeletons/usage-skeletons';

import styles from './ai-usage-pricing-page.module.scss';

// Kept out of the lazy AI usage chunk so the route skeleton can show the page's loading state without loading chart code.

export const AiUsagePricingPageSkeleton = () => (
  <div className={styles.page}>
    <AiUsagePricingHeader />
    <SummaryCardsSkeleton />
    <AiUsageChartSkeleton />
  </div>
);

export const AiUsagePricingHeader = () => (
  <div className={styles.header}>
    <h2 className={styles.title}>AI Usage & Pricing</h2>
  </div>
);

const SUMMARY_CARD_COUNT = 5;

export const SummaryCardsSkeleton = () => (
  <MetricCardsSkeleton count={SUMMARY_CARD_COUNT} testId="summary-card-skeleton" styles={styles} />
);

export const AiUsageChartSkeleton = () => <UsageChartSkeleton height={300} styles={styles} />;
